<template>
  <div class="device-warning-wrapper" v-if="!isMobile()">
    <!-- <div class="device-warning-alert"> -->
    <BpCustomColorLogo width="240" height="120" />
    <span class="device-warning-title">
      <b>Ops, esse dispositivo não é suportado</b></span
    >
    <span class="device-warning-text">
      O aplicativo é otimizado para dispositivos móveis. Por favor, acesse
      através de um celular ou tablet.
    </span>
    <!-- </div> -->
  </div>
</template>

<script>
import deviceDetection from '../mixins/deviceDetection';

import BpCustomColorLogo from '../assets/icones/BpCustomColorLogo.vue';

export default {
  name: 'DeviceWarning',
  mixins: [deviceDetection],
  components: {
    BpCustomColorLogo,
  },
  data() {
    return {
      isVisible: true,
    };
  },
};
</script>

<style scoped>
.device-warning-wrapper {
  z-index: 1000;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.device-warning-alert {
  /* background: linear-gradient(135deg, #232526 0%, #414345 100%); */
  color: #fff;
  border-radius: 18px;
  padding: 36px 32px;
  /* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.25); */
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 420px;
  width: 100%;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.device-warning-title {
  color: #ffffff;
  font-size: 2rem;
  font-weight: 700;
  font-family: 'montserratbold', sans-serif;
  padding-top: 8px;
}
.device-warning-text {
  font-family: 'montserrat', sans-serif;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  max-width: 40vw;
}
</style>
